<template>
    <ModalComponent
        :name="'email-' + id"
        title="Enviar entradas"
        v-on:close="() => close(false)"
    >
        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit">
            <div class="row">
                <div class="col-12">
                    <h3 class="font-weight-bold">Se enviarán las siguientes entradas</h3>
                </div>
                <div class="col-12">
                    <div class="table-responsive">
                        <table class="table table-hover text-nowrap">
                            <thead>
                                <tr>
                                    <th>Descripción</th>
                                    <th>Precio + G.G</th>
                                    <th>Código qr</th>
                                    <th>Zona</th>
                                    <th>Fila/Asiento</th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(entrada, index) in entradas">
                                    <tr :key="index">
                                        <td>{{ entrada.concepto }}</td>
                                        <td>{{ entrada.precio | calcular_precio_entrada(entrada) }}
                                        <td>{{ entrada.qr_code }}</td>
                                        <td>{{ entrada.asiento ? entrada.asiento.zona : '' }}</td>
                                        <td>
                                            <template v-if="entrada.asiento">
                                                {{ entrada.asiento.fila }}/{{ entrada.asiento.asiento }}
                                            </template>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="col-12" v-if="!loading">
                    <FormInput label="Email" type="email" name="email" rules="required|email" v-model="mail" />
                </div>
                <div class="col-12" v-else style="padding: 100px">
                    <LoaderComponent/>
                </div>
                <div class="col-12">
                    <Button type="submit" name="button" :disabled="loading">ENVIAR</Button>
                </div>
            </div>
        </ValidationObserver>
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";

    export default {
        props: ['entradas', 'id', 'sesion_id', 'evento_id', 'email', 'user_order'],
        data() {
            return {
                loading: false,
                mail: null
            }
        },
        created() {
            this.mail = this.email;
        },
        watch: {
            email() {
                this.mail = null;
                this.mail = this.email;
            }
        },
        methods: {
            close() {
                this.$emit('close', 'email-' + this.id);
            },
            enviarEntradas : function() {
                this.loading = true;
                var data = {
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id,
                    user_order: this.user_order,
                    qr_codes: [],
                    email: this.mail
                };

                for(var i in this.entradas) {
                    data.qr_codes.push(this.entradas[i].qr_code);
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.entradas.enviar.email'), data).then(res => {
                    this.$toast.success(res.data.message);
                    this.close();
                    this.$emit('updated');
                }).finally(() => this.loading = false);
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.enviarEntradas();
                }
            }
        },
        components: {
            ModalComponent
        }
    }
</script>
